import React from "react";
import {useTranslation} from "react-i18next";
import {CAView} from "./CustomerAccount";
import styles from "./CustomerAccountOverview.module.scss";
import {useCustomerSelector} from "../../../store";
import {getReturnPolicyDays} from "../../../helpers/getReturnPolicyDays";

type CustomerAccountSection = {
  headline: string;
  links: CustomerAccountLink[];
};

type CustomerAccountLink = {
  title: string;
  url?: string;
  view?: CAView;
};

const CustomerAccountOverview: React.FC<{
  element: HTMLElement;
  openView: (evt: React.MouseEvent<HTMLAnchorElement>, view: CAView) => void;
}> = ({element, openView}) => {
  const {customer} = useCustomerSelector();
  const linkCustomerOrders = element.dataset.linkcustomerorders;
  const linkCustomerBacks = element.dataset.linkcustomercreditnotes;
  const linkCustomerRatings = element.dataset.linkcustomerratings;
  const linkCustomerUserData = element.dataset.linkcustomeruserdata;
  const linkCustomerAddressData = element.dataset.linkcustomeraddressdata;
  const linkCustomerDelete = element.dataset.linkcustomerdelete;
  const linkCustomerLogOut = element.dataset.linkcustomerlogout;

  const sections: CustomerAccountSection[] = [
    {
      headline: "customer.yourOrders",
      links: [
        {title: "customer.yourOrders", url: linkCustomerOrders},
        {title: "customer.yourReturns", url: linkCustomerBacks},
        {title: "customer.yourReviews", url: linkCustomerRatings},
      ],
    },
    {
      headline: "customer.yourSubscriptions",
      links: [
        {title: "customer.yourPersonalData", url: linkCustomerUserData},
        {title: "customer.yourAddresses", url: linkCustomerAddressData},
        {
          title: customer.newsletterFlag ? "newsletter.newsletterOptions" : "newsletter.subscribe",
          view: CAView.Subscriptions,
        },
      ],
    },
    {
      headline: "customer.yourAccount",
      links: [
        {title: "customer.accountDeletionRequest", url: linkCustomerDelete},
        {title: "customer.logOut", url: linkCustomerLogOut},
      ],
    },
  ];

  const {t} = useTranslation();

  return (
    <React.Fragment>
      {!!getReturnPolicyDays() && (
        <div className={styles.accountSection}>
          <div className={styles.returnRequest}>
            <p>{t("customer.requestReturnDescription--days", {days: getReturnPolicyDays()})}</p>
            <a href={t("url.returnDocumentLink")} title={t("customer.requestReturn")}>
              {t("customer.requestReturn")}
            </a>
          </div>
        </div>
      )}

      {sections.map((section, index) => {
        return (
          <div key={index} className={styles.accountSection}>
            <h2 className={styles.accountSectionHeader}>{t(section.headline)}</h2>
            {section.links.map((link, linkIndex) => {
              return (
                <a
                  key={`link${linkIndex}`}
                  className={styles.accountSectionLink}
                  href={link.url}
                  onClick={(e) => {
                    if (link.view) {
                      openView(e, link.view);
                    }
                  }}
                >
                  <div>{t(link.title)}</div>
                  <div className={styles.arrow}>
                    <span className={"icon icon-chevron-right--blue"} />
                  </div>
                </a>
              );
            })}
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default CustomerAccountOverview;
